import { render } from "./Banner.vue?vue&type=template&id=5851d3f4&scoped=true"
const script = {}

import "./Banner.vue?vue&type=style&index=0&id=5851d3f4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5851d3f4"]])

export default __exports__